/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleDtoListApiResponse } from '../../models/role-dto-list-api-response';

export interface GetUserRolesAsync$Plain$Params {
  Email?: string;
}

export function getUserRolesAsync$Plain(http: HttpClient, rootUrl: string, params?: GetUserRolesAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDtoListApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserRolesAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('Email', params.Email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleDtoListApiResponse>;
    })
  );
}

getUserRolesAsync$Plain.PATH = '/api/user/roles';
